import React from 'react';
import LevelingRankPicker from './LevelingRankPicker';

export default class Leveling1to1000 extends React.PureComponent {
    static minValue = 1;
    static maxValue = 1000;

    static describeRank = rank => rank.toString();
    static getDefaultValue = () => [1, 300];

    static marks = {
        1: '1',
        200: '200',
        400: '400',
        600: '600',
        800: '800',
        1000: '1000',
    };

    render() {
        const { ...rest } = this.props;

        return (
            <LevelingRankPicker
                {...rest}
                min={Leveling1to1000.minValue}
                max={Leveling1to1000.maxValue}
                marks={Leveling1to1000.marks}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/levelingRankPicker/Leveling1to1000.js